import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { PartnersBanner } from "@/components/home/PartnersBanner";
import { PackagesPreview } from "@/components/home/PackagesPreview";

import { Testimonials, reviewSchema } from "@/components/home/Testimonials";
import { ConsultationForm } from "@/components/home/ConsultationForm";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SEO } from "@/components/SEO";
import { organizationSchema, siteNavigationSchema } from "@/lib/structuredData";

const Index = () => {
  return (
    <Layout>
      <SEO 
        title="Bookkeeping Services South Africa | SAICA Registered | Xero Partner"
        description="Looking for bookkeeping services in South Africa? SAICA-registered Chartered Accountant offering monthly packages from R2,500. Payroll, VAT, SARS compliance included. Get a free quote today."
        canonical="/"
        structuredData={[organizationSchema, siteNavigationSchema, reviewSchema]}
      />
      <HeroSection />
      <PartnersBanner />
      <PackagesPreview />
      
      <Testimonials />
      <ConsultationForm />
      <FinalCTA />
    </Layout>
  );
};

export default Index;
